import React from 'react';
import { connect } from 'react-redux';
import { Glyphicon, Button } from 'react-bootstrap';
import classnames from 'classnames';

class GlyphiconButton extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    // RENDER METHOD

    render = () => {
        let classNames = [];

        if (this.props.classNames) {
            let classNamesObject = {};

            for (let i = 0; i < this.props.classNames.length; ++i) {
                classNamesObject[this.props.classNames[i]] = true;
            }

            classNames = classnames(classNamesObject);
        }

        if (!this.props.text) {
            return (
                <Button className={classNames} onClick={this.props.handleClick}>
                    <Glyphicon glyph={this.props.name}/>
                </Button>
            );
        } else {
            return (
                <Button className={classNames} onClick={this.props.handleClick}>
                    <div className="clearfix">
                        <Glyphicon className="pull-left" glyph={this.props.name}/>
                        <span className="pull-right">&nbsp;&nbsp;<b>{this.props.text}</b></span>
                    </div>
                </Button>
            );
        }
    }
}

GlyphiconButton.propTypes = {
    name: React.PropTypes.string.isRequired,
    classNames: React.PropTypes.array,
    handleClick: React.PropTypes.func,
    text: React.PropTypes.string
};

export default connect()(GlyphiconButton);



/** WEBPACK FOOTER **
 ** ./src/app/components/GlyphiconButton.js
 **/